"use strict";
var ɵngcc0 = require('@angular/core');
var ɵngcc1 = require('@angular/common/http');
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var http_1 = require("@angular/common/http");
var operators_1 = require("rxjs/operators");
var deliverables_shared_service_1 = require("../deliverables-shared.service");
var deliverable_client_config_1 = require("../../deliverable.client.config");
var helpers_1 = require("../../helpers");
var i0 = require("@angular/core");
var i1 = require("@angular/common/http");
var i2 = require("../../deliverable.client.config");
//import { BfAuthService } from '@brafton/skynet-angular-security-service';
var ProductionService = /** @class */ (function () {
    /**
     * Initialises a new instance of the ProductionService /> class.
     * @param http
     * @param config
     */
    function ProductionService(http, 
    //private authService: BfAuthService,
    config) {
        this.http = http;
        this.config = config;
    }
    /**
  * remove tags on a production.
  * @param productionId
  * @param comment
  * @param tagIds
  */
    ProductionService.prototype.addTags = function (productionId, comment, tagIds, operatorOwnerId) {
        var request = {
            //operatorOwnerId: this.authService.profileId,
            operatorOwnerId: operatorOwnerId,
            comment: comment,
            tagIds: tagIds,
        };
        return this.http.post(this.config.DeliverablesApiURL + "/api/productions/" + productionId + "/addtags", request)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Assign a task.
     * @param taskId
     * @param ownerId
     * @param comment
     * @param operatorOwnerId
     */
    ProductionService.prototype.assignTask = function (taskId, ownerId, comment, operatorOwnerId) {
        var request = {
            operatorOwnerId: operatorOwnerId,
            comment: comment,
            ownerId: ownerId,
        };
        return this.http.put(this.config.DeliverablesApiURL + "/api/productions/" + taskId + "/assign", request)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * Gets a full production project
   * @param id
   * @returns An Observable containing the VideoProject
   */
    ProductionService.prototype.GetFullProject = function (productionId) {
        return this.http.get(this.config.DeliverablesApiURL + "/api/productions/" + productionId + "/full")
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * Gets a production project head
   * @param id
   * @returns An Observable containing the VideoProject
   */
    ProductionService.prototype.GetHeadProject = function (productionId) {
        return this.http.get(this.config.DeliverablesApiURL + "/api/productions/" + productionId + "/head")
            .pipe(operators_1.map(function (result) { return helpers_1.retrocycle(result); }), operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Add a Publish Product to the Production
     * @param productionId
     * @param addPublishProductionRequest
     */
    ProductionService.prototype.AddPublishProduct = function (productionId, addPublishProductionRequest) {
        return this.http.post(this.config.DeliverablesApiURL + "/api/productions/" + productionId + "/addpublish", addPublishProductionRequest)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
   * remove tags on a production.
   * @param productionId
   * @param comment
   * @param tagIds
   */
    ProductionService.prototype.removeTags = function (productionId, comment, tagIds, operatorOwnerId) {
        var request = {
            //operatorOwnerId: this.authService.profileId,
            operatorOwnerId: operatorOwnerId,
            comment: comment,
            tagIds: tagIds,
        };
        return this.http.put(this.config.DeliverablesApiURL + "/api/productions/" + productionId + "/removetags", request)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    /**
     * Assign a task.
     * @param taskId
     * @param ownerId
     * @param comment
     * @param operatorOwnerId
     */
    ProductionService.prototype.renameTask = function (taskId, name, comment, operatorOwnerId) {
        var request = {
            operatorOwnerId: operatorOwnerId,
            comment: comment,
            name: name,
        };
        return this.http.put(this.config.DeliverablesApiURL + "/api/productions/" + taskId + "/renametask", request)
            .pipe(operators_1.catchError(deliverables_shared_service_1.DeliverablesSharedService.handleError()));
    };
    ProductionService.ngInjectableDef = i0.defineInjectable({ factory: function ProductionService_Factory() { return new ProductionService(i0.inject(i1.HttpClient), i0.inject(i2.DELIVERABLE_CLIENT_CONFIG)); }, token: ProductionService, providedIn: "root" });
    ProductionService = __decorate([ __param(1, core_1.Inject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)),
        __metadata("design:paramtypes", [http_1.HttpClient, Object])
    ], ProductionService);
ProductionService.ɵfac = function ProductionService_Factory(t) { return new (t || ProductionService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG)); };
ProductionService.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: ProductionService, factory: function (t) { return ProductionService.ɵfac(t); }, providedIn: 'root' });
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ProductionService, [{
        type: core_1.Injectable,
        args: [{
                providedIn: 'root'
            }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: Object, decorators: [{
                type: core_1.Inject,
                args: [deliverable_client_config_1.DELIVERABLE_CLIENT_CONFIG]
            }] }]; }, null); })();
    return ProductionService;
}());
exports.ProductionService = ProductionService;

